import { useMutation } from "react-query";
import http from "infra/http";

interface usePostEmailSenhaProps {
  users: string[] | string;
  type: 'email'
}

function useReenvioEmailSenha() {
  return useMutation(({ users, type }: usePostEmailSenhaProps) => {

    return http.post(`v1/usuarios/reenviar-senha`, { users, type });
  },
    { retry: false }
  );
}

export default useReenvioEmailSenha;
